<template>
  <b-tab :lazy="lazy" :active="active" :title-link-class="navLinkClass" :title-item-class="navItemClass"
    :active-nav-item-class="'select-tab'" class="custom-tab-item" tag="div" @click="$emit('click', $event)">
    <template #title>
      <slot name="title" />
    </template>
    <slot name="content" />
  </b-tab>
</template>

<script>
import { BTab } from "bootstrap-vue";
export default {
  name: "TabItemHeader",
  components: {
    BTab,
  },
  props: {
    lazy: {
      type: Boolean,
      default: () => true,
    },
    active: {
      type: Boolean,
      default: () => false,
    },
    navItemClass: {
      type: [Object, String],
      default: () => '',
    },
    navLinkClass: {
      type: [Object, String],
      default: () => '',
    },
    navActiveClass: {
      type: [Object, String],
      default: () => '',
    }
  },
};
</script>
